<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="待审核" name="UNTREATED"></el-tab-pane>
      <el-tab-pane label="已审核" name="PASS"></el-tab-pane>
      <el-tab-pane label="未通过" name="NOT_PASS"></el-tab-pane>
    </el-tabs>

    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">所属行业</span>
        <el-cascader
            class="w150"
            clearable
            placeholder="全部"
            v-model="industry"
            :options="industryList"
            :props="{value: 'adIndustryId', label: 'industryName'}"
        />
      </div>
      <div class="dlblock-mb20 mr10" v-if="activeName == '2'">
        <span class="pr5">广告类型</span>
        <el-select v-model="type" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">广告主</span>
        <el-input v-model.trim="person" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getAdAuthPageFn()">
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" :key="activeName" v-loading="tableLoading"
              :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="title" label="广告标题"></el-table-column>
      <el-table-column align="center" prop="adType.desc" label="广告类型"></el-table-column>
      <el-table-column align="center" prop="userName" label="广告主"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="adIndustryName" label="所属行业"></el-table-column>

      <template v-if="activeName == 'PASS'">
        <el-table-column align="center" prop="spreadArea" label="推广区域"></el-table-column>
        <el-table-column align="center" prop="putInPosition" label="投放位置"></el-table-column>
        <el-table-column align="center" prop="payType.desc" label="付费类型"></el-table-column>
        <el-table-column align="center" prop="expendAmount" label="累计支出"></el-table-column>
        <el-table-column align="center" prop="visitorCount" label="累计拓客"></el-table-column>
        <el-table-column align="center" prop="adBalance" label="广告余额"></el-table-column>
        <el-table-column align="center" prop="platformBenefitRate" label="平台费用比例"></el-table-column>
        <el-table-column align="center" prop="platformBenefit" label="平台费用"></el-table-column>
        <el-table-column align="center" prop="status.desc" label="状态"></el-table-column>
      </template>
      <template v-else-if="activeName == 'NOT_PASS'">
        <el-table-column align="center" prop="remark" label="未通过原因"></el-table-column>
      </template>

      <el-table-column align="center" label="操作" width="120px">
        <template slot-scope="{row}">
          <a class="glob-a" v-if="activeName == 'UNTREATED'" @click="auditBtn(1, row)">审核</a>
          <a class="glob-a" v-else-if="activeName == 'NOT_PASS'" @click="auditBtn(2, row)">查看</a>

          <template v-if="activeName == 'PASS'">
            <a class="glob-a" @click="closeBtn(1, row)">查看</a>
            <a class="glob-a" v-if="row.status && row.status.name == 'PUTTING'" @click="closeBtn(2, row)">结束投放</a>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 认证审核 || 查看 -->
    <el-dialog :title="auditData.audit ? '审核' : '查看'" :visible.sync="auditData.modal" width="800px">
      <el-form label-width="120px">
        <template v-if="auditData.adType == 'NORMAL'">
          <el-form-item label="广告标题：">
            {{auditData.data.title}}
          </el-form-item>
          <el-form-item label="封面：">
            <video v-if="auditData.coverType == 'VIDEO' && auditData.data.videoUrl"
                   :src="auditData.data.videoUrl"
                   width="350" height="200">
            </video>
            <show-img v-if="auditData.coverType == 'IMAGE' && auditData.data.videoUrl"
                      :value="auditData.data.videoUrl"
            />
          </el-form-item>
          <el-form-item label="描述：">
            <div v-html="auditData.data.description"></div>
          </el-form-item>
        </template>

        <template v-else-if="auditData.adType == 'GOODS'">
          <el-form-item label="商品宣传语：">
            {{auditData.data.title}}
          </el-form-item>
          <el-form-item label="商品图片：">
            <show-img class="mr10" v-for="(item,index) in auditData.data.goodsImgList" :key="index" :value="item"/>
          </el-form-item>
          <el-form-item label="商品价格：">
            {{auditData.data.goodsPrice}}
          </el-form-item>
          <el-form-item label="描述：">
            <div v-html="auditData.data.description"></div>
          </el-form-item>
        </template>

        <template v-else-if="auditData.adType == 'VIDEO'">
          <el-form-item label="视频宣传语：">
            {{auditData.data.title}}
          </el-form-item>
          <el-form-item label="视频：">
            <video v-if="auditData.data.videoUrl" :src="auditData.data.videoUrl" width="350" height="200"></video>
          </el-form-item>
          <el-form-item label="描述：">
            <div v-html="auditData.data.description"></div>
          </el-form-item>
        </template>

        <template v-else-if="auditData.adType == 'OUT_LINK'">
          <el-form-item label="广告标题：">
            {{auditData.data.title}}
          </el-form-item>
          <el-form-item label="封面：">
            <video v-if="auditData.coverType == 'VIDEO' && auditData.data.videoUrl"
                   :src="auditData.data.videoUrl"
                   width="350" height="200">
            </video>
            <show-img v-if="auditData.coverType == 'IMAGE' && auditData.data.videoUrl"
                      :value="auditData.data.videoUrl"
            />
          </el-form-item>
          <el-form-item label="广告链接：">
            {{auditData.data.outLinkUrl}}
          </el-form-item>
        </template>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所属行业：">
              {{auditData.data.adIndustryName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付费类型：">
              {{auditData.data.payType && auditData.data.payType.desc}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="总投入上限：">
              {{auditData.data.totalCostLimit}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="日花费上限：">
              {{auditData.data.dayCostLimit}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发布人：">
              {{auditData.data.userName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间：">
              {{auditData.data.createTime}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="审核意见：" v-if="auditData.audit">
          <el-row>
            <el-col :span="6">
              <el-radio v-model="auditData.type" label="PASS">
                审核通过
              </el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio v-model="auditData.type" label="NOT_PASS">
                审核不通过
              </el-radio>

              <el-input
                  class="mt10 w400"
                  resize="none"
                  type="textarea"
                  :rows="4"
                  maxlength="100"
                  show-word-limit
                  v-model="auditData.content"
                  :disabled="auditData.type == 'PASS'"
              />
            </el-col>
          </el-row>
        </el-form-item>
        <el-row v-else>
          <el-col :span="12">
            <el-form-item label="状态：">
              未通过
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="未通过原因：">
              {{auditData.data.remark}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" v-if="auditData.audit">
        <el-button @click="auditData.modal = false">取 消</el-button>
        <el-button type="primary" @click="auditSave">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="msgModal" fullscreen>
      <detail :id="msgId"/>
    </el-dialog>
  </div>
</template>

<script>
  import ShowImg from '@/components/ShowImg.vue'
  import Detail from './Detail.vue'

  import {
    getAdAuthPage,
    getAdIndustryTree,
    setAdAuth,
    setAdClose
  } from '@/api'

  export default {
    name: 'AdAuth',
    components: {ShowImg, Detail},
    data () {
      return {
        title: '',
        date: [],
        person: '',
        industry: [],
        industryList: [],
        type: '',
        typeList: [
          {name: '通用广告', id: 'NORMAL'},
          {name: '商品广告', id: 'GOODS'},
          {name: '视频广告', id: 'VIDEO'},
          {name: '外链广告', id: 'OUT_LINK'}
        ],
        tableData: [],
        tableLoading: false,
        activeName: 'UNTREATED',
        pages: {
          page: 1,
          total: 0
        },
        auditData: {
          modal: false,
          data: {},
          adType: '',
          coverType: '',
          type: 'PASS',
          content: ''
        },
        msgId: '',
        msgModal: false
      }
    },
    watch: {
      activeName (n) {
        this.pages.page = 1;
        this.getAdAuthPageFn()
      }
    },
    created () {
      this.getAdAuthPageFn()
      this.getAdIndustryTreeFn()
    },
    methods: {
      // t: 1查看 2结束投放
      closeBtn (t, row) {
        switch (t) {
          case 1:
            this.msgId = row.advertisingId
            this.msgModal = true
            break
          case 2:
            this.$confirm('确认取消投放吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setAdClose(row.advertisingId).then(res => {
                this.$message.success(res.data)
                this.getAdAuthPageFn()
              })
            }).catch(() => {
            })
            break
        }
      },
      auditSave () {
        setAdAuth({
          advertisingId: this.auditData.data.advertisingId,
          auditStatus: this.auditData.type,
          remark: this.auditData.type == 'PASS' ? '' : this.auditData.content
        }).then(res => {
          this.$message.success(res.data)
          this.auditData.modal = false
          this.getAdAuthPageFn()
        })
      },
      // t: 1审核 2查看
      auditBtn (t, row) {
        this.auditData = {
          modal: true,
          audit: t === 1,
          data: row,
          adType: row.adType.name,
          coverType: row.coverType ? row.coverType.name : '',
          type: 'PASS',
          content: ''
        }
      },
      getAdAuthPageFn () {
        this.tableLoading = true
        getAdAuthPage({
          auditStatus: this.activeName,
          title: this.title,
          pageNum: this.pages.page,
          startTime: this.date && this.date.length ? this.date[0] : '',
          endTime: this.date && this.date.length > 1 ? this.date[1] : '',
          userName: this.person,
          adType: this.type,
          adIndustryId: this.industry.length ? this.industry[this.industry.length - 1] : '',
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      getAdIndustryTreeFn () {
        getAdIndustryTree().then(res => {
          this.industryList = res.data.children
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getAdAuthPageFn()
      },
    }
  }
</script>

<style scoped>

</style>
